var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"instagram-media w-1/2 lg:w-1/4",attrs:{"href":`https://www.instagram.com/numbersgameuk/`,"target":"_blank"}},[_c('div',{staticClass:"pt-[100%] relative"},[_c('img',{staticClass:"w-full h-full object-cover absolute inset-0",attrs:{"src":`/instagram-posts/${_vm.postImage}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }